import React from 'react';
import PropTypes from 'prop-types';

export default function CheckIcon({ width, height, color }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 18"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="2.0-Users"
          transform="translate(-41.000000, -163.000000)"
          fill="#FFFFFF"
        >
          <path
            d="M62.7606849,163.56344 C62.0093801,162.812187 60.7572054,162.812187 60.0047974,163.56344 L48.8907818,174.663448 L44.3443396,170.072091 C43.5643506,169.336283 42.3408601,169.336283 41.5608711,170.101877 C40.8106696,170.880708 40.8106696,172.104114 41.5752132,172.882946 L47.4323017,178.710947 L47.5139412,178.806922 C48.2806914,179.586857 49.5174207,179.586857 50.2830676,178.806922 L62.7606849,166.332374 C63.5263318,165.566781 63.5263318,164.32793 62.7606849,163.56344 L62.7606849,163.56344 Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
}

CheckIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

CheckIcon.defaultProps = {
  color: '#FFFFFF',
  width: 23,
  height: 17,
};
